import React from "react";
import Grid from "@mui/material/Grid";

import {
  EventInformation,
  FaqPage,
  GuestSpeakers,
  Partners,
  LinkToRegisterButton,
  ChallengesPrizes,
  CountdownTimer,
} from "src/library/components/exports";
import {
  INTRO_ENABLED,
  EVENT_INFORMATION_ENABLED,
  CHALLENGES_PRIZES_ENABLED,
  GUEST_SPEAKERS_ENABLED,
  PARTNERS_ENABLED,
  FAQ_ENABLED,
} from "src/library/constants";
import HackathonIntro from "./HackathonIntro";
import { RoutingIDEnum } from "src/library/types/types";
import { getZIndex, sectionBackgroundColors } from "src/library/styles/theme";
import { useHackathonContext } from "src/library/store/GlobalStateProvider";
// import { Typography } from "@mui/material";

export default function MainPage() {
  const { state } = useHackathonContext();

  return (
    <Grid container direction="column">
      {INTRO_ENABLED && (
        <Grid
          item
          id={RoutingIDEnum.Home}
          component="section"
          sx={{
            py: 2,
            bgcolor: sectionBackgroundColors.intro,
            zIndex: getZIndex(sectionBackgroundColors.intro),
            position: "relative",
          }}
        >
          <HackathonIntro />
        </Grid>
      )}
      {/* <Typography
        variant="h4"
        component="p"
        fontWeight="fontWeightBold"
        color="text.light"
        textAlign="center"
        py={1}
        pb={5}
      >
        Registrations now closed
      </Typography> */}
      {EVENT_INFORMATION_ENABLED && (
        <Grid
          item
          id={RoutingIDEnum.Event}
          component="section"
          sx={{
            pt: 1,
            position: "relative",
            bgcolor: sectionBackgroundColors.eventInformation,
            zIndex: getZIndex(sectionBackgroundColors.eventInformation),
          }}
        >
          <EventInformation />
        </Grid>
      )}
      {CHALLENGES_PRIZES_ENABLED && (
        <Grid
          item
          id={RoutingIDEnum.ChallengesPrizes}
          component="section"
          sx={{
            pt: 1,
            position: "relative",
            bgcolor: sectionBackgroundColors.challengesPrizes,
            zIndex: getZIndex(sectionBackgroundColors.challengesPrizes),
          }}
        >
          <ChallengesPrizes />
        </Grid>
      )}
      {GUEST_SPEAKERS_ENABLED && (
        <Grid
          item
          id={RoutingIDEnum.Guests}
          component="section"
          sx={{
            pt: 1,
            position: "relative",
            bgcolor: sectionBackgroundColors.guestSpeakers,
            zIndex: getZIndex(sectionBackgroundColors.guestSpeakers),
          }}
        >
          <GuestSpeakers sectionBackGroundColor={sectionBackgroundColors.guestSpeakers} />
        </Grid>
      )}
      {PARTNERS_ENABLED && (
        <Grid
          item
          id={RoutingIDEnum.Partners}
          component="section"
          sx={{
            pt: 1,
            position: "relative",
            bgcolor: sectionBackgroundColors.partners,
            zIndex: getZIndex(sectionBackgroundColors.partners),
          }}
        >
          <Partners sectionBackGroundColor={sectionBackgroundColors.partners} />
        </Grid>
      )}
      {FAQ_ENABLED && (
        <Grid
          item
          id={RoutingIDEnum.Faq}
          component="section"
          sx={{
            pt: 1,
            position: "relative",
            bgcolor: sectionBackgroundColors.faq,
            zIndex: getZIndex(sectionBackgroundColors.faq),
          }}
        >
          <FaqPage />
        </Grid>
      )}
      <Grid
        item
        sx={{
          pb: 3,
          position: "relative",
          bgcolor: sectionBackgroundColors.linkToRegisterButton,
          zIndex: getZIndex(sectionBackgroundColors.linkToRegisterButton),
        }}
      >
        {/* <Typography
          variant="h4"
          component="p"
          fontWeight="fontWeightBold"
          color="text.light"
          textAlign="center"
          py={1}
          pb={5}
        >
          Registrations now closed
        </Typography> */}
        <CountdownTimer />
      </Grid>
      {state.registrationsAvailable && (
        <Grid
          item
          sx={{
            pb: 3,
            position: "relative",
            bgcolor: sectionBackgroundColors.linkToRegisterButton,
            zIndex: getZIndex(sectionBackgroundColors.linkToRegisterButton),
          }}
        >
          <LinkToRegisterButton buttonText="Secure Your Spot" />
        </Grid>
      )}
    </Grid>
  );
}
